import React from "react";

export const List = ({ className = "", dense, children, ...rest }) => (
  <ul className={`m-0 list-none p-0 ${dense ? "" : ""} ${className}`} {...rest}>
    {children}
  </ul>
);

export const ListItem = ({
  className = "",
  button = false,
  selected = false,
  disableGutters = false,
  divider = false,
  children,
  ...rest
}) => (
  <li
    className={`flex items-center gap-3 ${disableGutters ? "" : "px-4"} py-2 ${
      button ? "cursor-pointer hover:bg-farmazon-hover" : ""
    } ${selected ? "bg-farmazon-hover" : ""} ${divider ? "border-b border-farmazon-border" : ""} ${className}`}
    {...rest}
  >
    {children}
  </li>
);

export const ListItemAvatar = ({ className = "", children, ...rest }) => (
  <div className={`shrink-0 ${className}`} {...rest}>
    {children}
  </div>
);

export const ListItemIcon = ({ className = "", children, ...rest }) => (
  <div className={`flex shrink-0 items-center text-farmazon-text-muted ${className}`} {...rest}>
    {children}
  </div>
);

export const ListItemText = ({ primary, secondary, className = "", ...rest }) => (
  <div className={`min-w-0 flex-1 ${className}`} {...rest}>
    {primary && <div className="truncate text-sm text-farmazon-text">{primary}</div>}
    {secondary && <div className="truncate text-xs text-farmazon-text-muted">{secondary}</div>}
  </div>
);

export const ListItemSecondaryAction = ({ className = "", children, ...rest }) => (
  <div className={`ml-auto flex shrink-0 items-center ${className}`} {...rest}>
    {children}
  </div>
);

export default List;
